import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Clock from "../components/Clock";
import Footer from "../components/footer";
import { DAppClient, NetworkType } from "@airgap/beacon-sdk";
import { TezosToolkit } from "@taquito/taquito";
import { BeaconWallet } from "@taquito/beacon-wallet";
import CustomToastContainer from "../../Common/CustomToastContainer";
import { createGlobalStyle } from "styled-components";
import { useNavigate } from "react-router-dom";
import { getData, postData } from "../../Common/api";

const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const generateAvatarurl = process.env.REACT_APP_GENERATE_AVATAR_URL;

const GlobalStyles = createGlobalStyle`
  .logout{
    display: flex;
    align-items: center;
  }
`;
const tezos = new TezosToolkit(process.env.REACT_APP_RPC_URL); // or use a custom RPC endpoint

const wallet = new BeaconWallet({
  name: "ArtCollect",
  preferredNetwork: NetworkType.GHOSTNET, // or GHOSTNET
});

tezos.setWalletProvider(wallet);
const Editpage = () => {
  const { nftId } = useParams();
  const toastRef = useRef();
  const toTez = (mutez) => mutez / 1000000;
  const navigate = useNavigate();
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [file, setFile] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [userAddress, setUserAddress] = useState();
  const [loading, setLoading] = useState(false);
  const [creatorSales, setCreatorSales] = useState(0);
  const [showSellOption, setShowSellOption] = useState(false);
  const [auctionStartTime, setAuctionStartTime] = useState("");
  const [auctionEndTime, setAuctionEndTime] = useState("");
  const [editionCount, setEditionCount] = useState(1);
  const [auctionDuration, setAuctionDuration] = useState(1);
  const [showAuctionOption, setShowAuctionOption] = useState(false);
  const [auctionValidation, setAuctionValidation] = useState({
    isValid: true,
    message: "",
  });
  const [previewUrl, setPreviewUrl] = useState("");
  const [nftDetails, setNftDetails] = useState(null);

  const [formData, setFormData] = useState({
    item_title: "",
    item_desc: "",
    item_price: "0.0",
    item_royalties: "10",
    item_likes: "0",
    open_to_offers: false,
    open_to_sell: false,
    open_to_auction: false,
    minimum_bid: "0.5",
  });

  useEffect(() => {
    const fetchSalesData = async () => {
      setLoading(true);
      const storedAddress = localStorage.getItem("walletAddress");
      if (storedAddress) {
        setUserAddress(storedAddress);
        setWalletAddress(storedAddress);
        generateAvatar(storedAddress);

        try {
          const salesResponse = await fetch(
            `${domainpath}/api/sales-count/${storedAddress}`
          );
          if (salesResponse.data.sales_count >= 10) {
            setShowAuctionOption(true);
            setShowSellOption(true);
            // setShowBurnSellModal(false);
            setLoading(false);
          } else if (salesResponse.data.sales_count >= 0) {
            //  setShowBurnSellModal(true);
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching sales data:", error);
        }
      }
    };

    fetchSalesData();
  }, []);

  const formatDateTimeLocal = (isoString) => {
    const date = new Date(isoString);
    return date.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
  };

  useEffect(() => {
    const convertIPFSToHTTP = (url) => {
      if (!url) return "";
      return url.startsWith("ipfs://")
        ? url.replace("ipfs://", "https://ipfs.io/ipfs/")
        : url;
    };
    const fetchMimeType = async (url, nftdata) => {
      try {
        const res = await fetch(url, { method: "HEAD" });
        return res.headers.get("Content-Type");
      } catch (err) {
        ////console.error("Error fetching MIME type:", err);
        return nftdata.mime_type;
      }
    };
    const fetchNftDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${domainpath}/api/nfts/${nftId}`);
        if (!response.ok) {
          throw new Error(
            `Failed to fetch NFT details (status ${response.status})`
          );
        }

        const data = await response.json();
        console.log(data, "data");

        setNftDetails(data);

        const metadata = data.metadata || {};
        const artifactUri = metadata.artifactUri || data.ipfs_url || "";
        let mimeType = "";

        // Parse formats and extract mimeType
        const fileurl = await convertIPFSToHTTP(data.ipfs_url);
        mimeType = await fetchMimeType(fileurl, data);
        setFile({ url: fileurl, type: mimeType });
        // console.log(data, "data");

        setFormData({
          item_title: data.name || "",
          item_desc: data.description || "",
          item_price: data.price ? toTez(data.price) : 0,
          item_royalties: data.royalties ? data.royalties.toString() : "10",
          item_likes: data.likes ? data.likes.toString() : "0",
          open_to_offers: !!data.open_to_offers,
          open_to_sell: !!data.open_to_sell,
          open_to_auction: !!data.open_to_auction,
          minimum_bid: data.minimum_bid ? data.minimum_bid.toString() : "0.5",
        });

        setTags(metadata.tags ? JSON.parse(metadata.tags) : []);
        setEditionCount(data.edition || 1);
        setAuctionDuration(data.auction_duration || 1);

        if (data.open_to_auction && data.auction_details) {
          if (data.auction_details.start_time) {
            setAuctionStartTime(
              formatDateTimeLocal(data.auction_details.start_time)
            );
          }
          if (data.auction_details.end_time) {
            setAuctionEndTime(
              formatDateTimeLocal(data.auction_details.end_time)
            );
          }
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching NFT details:", error);
        setLoading(false);
      }
    };

    if (nftId) {
      fetchNftDetails();
    }
  }, []);

  const generateAvatar = (walletAddress) => {
    setProfileImage(`${generateAvatarurl}/${walletAddress}.png?size=200x200`);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (checked) {
        setFormData((prevData) => ({
          ...prevData,
          open_to_offers: name === "open_to_offers" ? true : false,
          open_to_sell: name === "open_to_sell" ? true : false,
          open_to_auction: name === "open_to_auction" ? true : false,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: false,
        }));
      }
      if (name === "open_to_auction" && !checked) {
        setAuctionValidation({ isValid: true, message: "" });
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleAuctionTimeChange = (e, type) => {
    const value = e.target.value;
    if (type === "start") {
      setAuctionStartTime(value);
    } else {
      setAuctionEndTime(value);
    }

    if (auctionStartTime && auctionEndTime) {
      validateAuctionTimes();
    }
  };

  const validateAuctionTimes = () => {
    if (!auctionStartTime || !auctionEndTime) {
      setAuctionValidation({
        isValid: false,
        message: "Both start and end times are required",
      });
      return false;
    }

    const start = new Date(auctionStartTime);
    const end = new Date(auctionEndTime);

    if (start >= end) {
      setAuctionValidation({
        isValid: false,
        message: "End time must be after start time",
      });
      return false;
    }

    setAuctionValidation({ isValid: true, message: "" });
    return true;
  };

  const handleTagKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && tagInput.trim()) {
      e.preventDefault();
      const newTag = tagInput.trim().replace(/,$/, "");
      if (!tags.includes(newTag) && newTag.length > 0) {
        setTags([...tags, newTag]);
      }
      setTagInput("");
    }
  };

  const removeTag = (indexToRemove) => {
    setTags(tags.filter((_, i) => i !== indexToRemove));
  };

  const handleUpdate = async () => {
    if (!walletAddress) {
      toastRef.current.addToast("Connect your wallet first.", "error");
      return;
    }

    setLoading(true);

    try {
      // Ensure wallet is connected and client is available
      let activeAccount = await wallet.client.getActiveAccount();
      if (!activeAccount) {
        console.log("Requesting permissions...");
        await wallet.requestPermissions({
          network: { type: NetworkType.GHOSTNET },
        });
        activeAccount = await wallet.client.getActiveAccount();
        if (!activeAccount) {
          toastRef.current.addToast("Wallet connection failed.", "error");
          setLoading(false);
          return;
        }
        localStorage.setItem("walletAddress", activeAccount.address);
        setUserAddress(activeAccount.address);
        setWalletAddress(activeAccount.address);
        generateAvatar(activeAccount.address);
      }

      const contract = await tezos.wallet.at(
        process.env.REACT_APP_CONTRACT_ADDRESS
      );

      const updateData = {
        token_id: parseInt(nftId),
        price: parseFloat(formData.item_price || 0) * 1_000_000,
        open_to_sell: formData.open_to_sell,
        open_to_auction: formData.open_to_auction,
        open_to_offers: formData.open_to_offers,
        description: formData.item_desc,
        ipfs_url: nftDetails.ipfs_url,
        nft_type: nftDetails.nft_type || "image",
        name: formData.item_title,
        symbol: "NFT",
        tags: tags,
        mime_type: nftDetails.mime_type || "image/png",
        creators_json: nftDetails.metadata.creators,
        formats_json: nftDetails.metadata.formats,
        auction_start_time: formData.open_to_auction
          ? Math.floor(new Date(auctionStartTime).getTime() / 1000)
          : 0,
        auction_end_time: formData.open_to_auction
          ? Math.floor(new Date(auctionEndTime).getTime() / 1000)
          : 0,
        minimum_bid: formData.open_to_auction
          ? parseFloat(formData.minimum_bid || 0) * 1_000_000
          : 0,
      };
      const operation = await contract.methods
        .edit_nft(
          updateData.token_id,
          updateData.price,
          updateData.open_to_sell,
          updateData.open_to_auction,
          updateData.open_to_offers,
          updateData.description,
          updateData.ipfs_url,
          updateData.nft_type,
          updateData.name,
          updateData.symbol,
          updateData.tags,
          updateData.mime_type,
          updateData.creators_json,
          updateData.formats_json,
          updateData.auction_start_time,
          updateData.auction_end_time,
          updateData.minimum_bid
        )
        .send();

      toastRef.current.addToast("Updating NFT...", "info");
      await operation.confirmation(1);
      toastRef.current.addToast("NFT updated successfully!", "success");
      navigate(`/edit/${nftId}`); // Redirect to the NFT page after update
    } catch (error) {
      console.error("Error updating NFT:", error);
      toastRef.current.addToast(
        `Failed to update NFT: ${error.message}`,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  if (!nftDetails && loading) {
    return (
      <div className="RoadmapSpinnerDiv">
        <span className="RoadmapSpinner"></span>
      </div>
    );
  }

  if (!nftDetails) {
    return <div>NFT not found</div>;
  }

  return (
    <>
      <div>
        <GlobalStyles />
        <section className="jumbotron breadcumb no-bg">
          <div className="mainbreadcumb">
            <div className="container">
              <div className="row m-10-hor">
                <div className="col-12">
                  <h1 className="text-center">Edit NFT</h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="container">
          <div className="row">
            <div className="col-lg-7 offset-lg-1 mb-5">
              <form id="form-edit-item" className="form-border">
                <div className="field-set">
                  {/* <div className="d-create-file">
                    <p id="file_name">
                      PNG, JPG, GIF, WEBP, MP4 or MP3. Max 200MB.
                      {nftDetails.ipfs_url && (
                        <span>
                         
                        </span>
                      )}
                    </p>
                    {file && <p>{file.name}</p>}

                    <div className="browse">
                      <input
                        type="button"
                        id="get_file"
                        className="btn-main"
                        value="Browse"
                        onClick={() =>
                          document.getElementById("upload_file").click()
                        }
                      />
                      <input
                        id="upload_file"
                        type="file"
                        accept="image/png, image/jpeg, image/webp, image/gif, video/mp4, audio/mpeg"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </div>
                  </div> */}

                  <div className="spacer-single"></div>

                  <h5>
                    Title <span style={{ color: "red" }}>*</span>
                  </h5>
                  <input
                    type="text"
                    name="item_title"
                    defaultValue={formData.item_title}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="e.g. 'Crypto Funk'"
                  />

                  <div className="spacer-10"></div>

                  <h5>Description</h5>
                  <textarea
                    name="item_desc"
                    value={formData.item_desc}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="e.g. 'This is very limited item'"
                  ></textarea>

                  <div className="spacer-10"></div>

                  <h5>Royalties</h5>
                  <input
                    type="number"
                    min={0}
                    name="item_royalties"
                    value={formData.item_royalties}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Suggested: 0, 10%, 20%, 30%. Maximum is 70%"
                  />

                  <div className="spacer-10"></div>

                  <h5>Listing Options</h5>
                  <div className="de_tab tab_methods">
                    <ul className="de_nav">
                      <li
                        id="btn1"
                        className={formData.open_to_sell ? "active" : ""}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            open_to_sell: true,
                            open_to_offers: false,
                            open_to_auction: false,
                          }))
                        }
                      >
                        <span>
                          <i className="fa fa-tag"></i>Fixed price
                        </span>
                      </li>
                      <li
                        id="btn2"
                        className={formData.open_to_auction ? "active" : ""}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            open_to_auction: true,
                            open_to_sell: false,
                            open_to_offers: false,
                          }))
                        }
                      >
                        <span>
                          <i className="fa fa-hourglass-1"></i>Timed auction
                        </span>
                      </li>
                      <li
                        id="btn3"
                        className={formData.open_to_offers ? "active" : ""}
                        onClick={() =>
                          setFormData((prevData) => ({
                            ...prevData,
                            open_to_offers: true,
                            open_to_sell: false,
                            open_to_auction: false,
                          }))
                        }
                      >
                        <span>
                          <i className="fa fa-users"></i>Open for bids
                        </span>
                      </li>
                    </ul>
                  </div>

                  {formData.open_to_auction && (
                    <>
                      <div className="spacer-10"></div>
                      <h5>Auction Time Range</h5>
                      <div className="row flex">
                        <div className="col-md-4">
                          <label>Start Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={auctionStartTime}
                            onChange={(e) =>
                              handleAuctionTimeChange(e, "start")
                            }
                            min={new Date().toISOString().slice(0, 16)}
                          />
                        </div>
                        <div className="col-md-4">
                          <label>End Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={auctionEndTime}
                            onChange={(e) => handleAuctionTimeChange(e, "end")}
                            min={new Date().toISOString().slice(0, 16)}
                          />
                        </div>
                        <div className="col-md-4">
                          <label>Minimum Bid (XTZ)</label>
                          <input
                            type="number"
                            name="minimum_bid"
                            className="form-control"
                            value={formData.minimum_bid}
                            onChange={handleInputChange}
                            min="0"
                            step="0.01"
                            placeholder="Enter minimum bid in XTZ"
                          />
                        </div>
                      </div>

                      {!auctionValidation.isValid && (
                        <div className="text-danger mt-2">
                          {auctionValidation.message}
                        </div>
                      )}
                    </>
                  )}

                  {formData.open_to_sell && (
                    <>
                      <div className="spacer-10"></div>
                      <h5>Price</h5>
                      <input
                        type="number"
                        min={0}
                        name="item_price"
                        value={formData.item_price}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter price for one item (ꜩ)"
                      />
                    </>
                  )}

                  <div className="spacer-10"></div>

                  <h5>Tags</h5>
                  <div className="tags-input-wrapper mt-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter tags and press Enter"
                      value={tagInput}
                      onChange={(e) => setTagInput(e.target.value)}
                      onKeyDown={handleTagKeyDown}
                    />
                    <div className="tags-list">
                      {tags.map((tag, index) => (
                        <span key={index} className="tag">
                          {tag}
                          <span
                            className="remove-tag"
                            onClick={() => removeTag(index)}
                          >
                            &times;
                          </span>
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="spacer-10"></div>
                  <input
                    type="button"
                    id="submit"
                    className="btn-main"
                    value="Update Item"
                    onClick={handleUpdate}
                  />
                </div>
              </form>
            </div>
            {console.log(nftDetails, "nftDetails")}
            <div className="col-lg-3 col-sm-6 col-xs-12">
              <h5>Preview item</h5>
              <div className="nft__item m-0">
                <div className="author_list_pp">
                  <span>
                    <img
                      className="lazy"
                      // src={
                      //   generateAvatar(nftDetails?.owner) ||
                      //   "./img/author/author-1.jpg"
                      // }
                      alt=""
                    />
                    <i className="fa fa-check"></i>
                  </span>
                </div>
                <div className="nft__item_first ">
                  <div
                    className={
                      file?.type?.startsWith("audio/")
                        ? "music_nft nft__item_wrap"
                        : "nft__item_wrap"
                    }
                    style={
                      file?.type?.startsWith("audio/")
                        ? { height: "400px" }
                        : {}
                    }
                  >
                    {console.log(file, "file")}
                    <span>
                      {file?.url ? (
                        <>
                          {file?.type?.startsWith("image/") ? (
                            <img
                              src={file?.url}
                              className="lazy nft__item_preview"
                              alt="NFT"
                            />
                          ) : file?.type?.startsWith("video/") ? (
                            <video
                              src={file?.url}
                              className="lazy nft__item_preview"
                              controls
                            />
                          ) : file?.type?.startsWith("audio/") ? (
                            <audio
                              src={file?.url}
                              controls
                              style={{ width: "90%", margin: "0 auto" }}
                            />
                          ) : (
                            <p>Unsupported media format</p>
                          )}
                        </>
                      ) : (
                        <img
                          src="./img/items/dummy.jpg"
                          className="lazy nft__item_preview"
                          alt="NFT"
                        />
                      )}
                    </span>
                  </div>
                </div>
                <div className="nft__item_info">
                  <span>
                    <h4>{formData.item_title || "Untitled"}</h4>
                  </span>
                  <div className="nft__item_price">
                    {!formData.open_to_offers
                      ? `${formData.item_price + "ꜩ"}`
                      : "Open to Offers"}
                  </div>
                  {editionCount > 1 && (
                    <div className="nft__item_edition">
                      Edition: {editionCount}
                    </div>
                  )}
                  <div className="nft__item_action">
                    <span>{formData.item_desc || ""}</span>
                  </div>
                  <div className="nft__item_like">
                    <i className="fa fa-heart"></i>
                    <span>{formData.item_likes || 0}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
      {loading && (
        <div className="RoadmapSpinnerDiv" id="RoadmapSpinnerDiv">
          <span className="RoadmapSpinner"></span>
        </div>
      )}
      <CustomToastContainer ref={toastRef} />
    </>
  );
};

export default Editpage;
